import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HaUiCommonModule } from "@ha/ui/common";
import { HaUiFormsModule } from "@ha/ui/forms";
import { TranslocoModule } from "@ngneat/transloco";
import { NgxsModule } from "@ngxs/store";
import { DisableMfaModalComponent } from "./components/disable-mfa-modal/disable-mfa-modal.component";
import { MfaSetupComponent } from "./components/mfa-setup/mfa-setup.component";
import { MfaState } from "./states/mfa.state";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        TranslocoModule,
        HaUiCommonModule,
        HaUiFormsModule,
        NgxsModule.forFeature([MfaState]),
    ],
    declarations: [DisableMfaModalComponent, MfaSetupComponent],
    exports: [DisableMfaModalComponent, MfaSetupComponent],
})
export class FeatureMfaModule {}
